import {ChangeDetectionStrategy, Component} from '@angular/core';
import {PageTitleLayoutComponent} from "../../../components/page-title-layout/page-title-layout.component";
import {Accordion, AccordionContent, AccordionHeader, AccordionPanel} from "primeng/accordion";
import {SignupButtonComponent} from "../../../components/signup-button/signup-button.component";

@Component({
  selector: 'homey-mobile-common-questions',
  imports: [
    PageTitleLayoutComponent,
    Accordion,
    AccordionPanel,
    AccordionHeader,
    SignupButtonComponent,
    AccordionContent
  ],
  templateUrl: './mobile-common-questions.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MobileCommonQuestionsComponent {
  readonly faqs: { question: string, answer: string }[] = [
    {
      question: 'Is Homey affiliated with the NYC government?',
      answer: 'We\'re not affiliated with the NYC government or the official housing lottery system. We just make the process easier by managing all the paperwork for you.'
    }, {
      question: 'What is the NYC Housing Lottery?',
      answer: 'The NYC Housing Lottery is a city-run program that offers the chance to secure a brand-new, rent-stabilized apartment at an affordable rate.'
    }, {
      question: 'Do I qualify?',
      answer: 'The NYC Housing Lottery is open to a broad range of incomes, not just low-income households. Depending on the building, eligible incomes can be as high as $240,000 per year.'
    }, {
      question: 'What happens to my data?',
      answer: 'We take your privacy seriously. We never share your data with third parties aside from the official NYC housing lottery system.'
    }
  ]
}
